import FeaturedProducts from "./FeaturedProducts";

export { default as FeaturedProductsFragment } from "./FeaturedProductsFragment.gql";
export default FeaturedProducts;
